import EStatusConta from 'modules/lotes/domain/entities/EStatusConta'
import Usuario from './DadosUsuario'

export default class Frotista {
  id: number
  cnpj: string
  antt: string
  razao_social?: string
  nome_fantasia?: string
  email: string
  telefone: string
  status: string
  protocolo_ocr: string
  is_matriz: boolean
  data_fundacao?: Date
  status_integracao?: string
  mensagem_ocr?: string
  status_conta?: EStatusConta
  mensagem_status_conta?: string
  usuarios: Usuario[]
  natureza_juridica?: string
  data_criacao_onboarding_pay?: Date
  quarteirizacao?: boolean
}
